import { ServerStatus } from '../../interface';
import { Server } from '../../../units/server/server';
import ServerInterface = Server.ServerInterface;
import GameServerQueryResponse = Server.GameServerQueryResponse;
import VoiceServerQueryResponse = Server.VoiceServerQueryResponse;
import ServerEventType = Server.ServerEventType;

export const BASE_SELECTOR: string = '.cluster__server';
const statusTemplate = require('./view/status.handlebars');

export class ClusterNodeUI {
    private static _actionsInitialized = false;

    static get actionsInitialized(): boolean {
        console.log("in the alas cluster");
        return this._actionsInitialized;
    }

    static set actionsInitialized(value: boolean) {
        this._actionsInitialized = value;
    }

    /**
     *
     */
    public renderServerInformations(promise: Promise<GameServerQueryResponse | VoiceServerQueryResponse>, server: ServerInterface): void {
        let gameserverResponse: Promise<Server.GameServerQueryResponse>
            = <Promise<GameServerQueryResponse>>promise;

        gameserverResponse.then(response => {
            $(`[data-atlas-name-${server.serverId}]`).text(
                response.name
            );
            $(`[data-atlas-slots-${server.serverId}]`).text(
                response.currentPlayers + ' / ' + response.maxPlayers
            );
        })
    }

    public constructor(private $base: JQuery) {
        if (ClusterNodeUI.actionsInitialized !== true) {
            window.addEventListener(ServerEventType.GAMESERVERINITIALISED_EVENT, () => {
                let atlasServer: ServerInterface = Server.ServerUnit.getActiveServer();

                // console.log('Active Server:');
                // console.log(Server.ServerUnit.getActiveServer());

                atlasServer.options = new Server.ServerOptions(true, 5000);
                atlasServer.options.queryEvent.addEventListener(Server.ServerEventType.GAMESERVERQUERY_EVENT, query => {
                    this.renderServerInformations(query, atlasServer)
                });

                if (atlasServer.cluster) {
                    for (let clusterKey in atlasServer.clusterServer) {
                        let clusterServer = atlasServer.clusterServer[clusterKey];

                        if (clusterServer.serverId != atlasServer.serverId) {
                            // console.log('Cluster Server:');
                            // console.log(clusterServer);

                            clusterServer.options = new Server.ServerOptions(true, 5000);
                            clusterServer.options.queryEvent.addEventListener(Server.ServerEventType.GAMESERVERQUERY_EVENT, query => {
                                this.renderServerInformations(query, clusterServer);
                            });
                        }
                    }
                }
            });

            ClusterNodeUI.actionsInitialized = true;
        }
    }

    public getServerId(): string {
        return this.$base.data('service-id') as string;
    }

    public updateState(state: ServerStatus) {
        let data: { status: string };

        switch (state) {
            case ServerStatus.Install:
                data = {status: 'Installing'};
                break;
            case ServerStatus.Loading:
                data = {status: 'Loading'};
                break;
            case ServerStatus.Maintenance:
                data = {status: 'Maintenance'};
                break;
            case ServerStatus.PreInstall:
                data = {status: 'Pre Install'};
                break;
            case ServerStatus.Removing:
                data = {status: 'Removing'};
                break;
            case ServerStatus.Running:
                data = {status: 'Running'};
                break;
            case ServerStatus.Starting:
                data = {status: 'Starting'};
                break;
            case ServerStatus.Stopped:
                data = {status: 'Stopped'};
                break;
            case ServerStatus.Stopping:
                data = {status: 'Stopping'};
                break;
            case ServerStatus.Suspended:
                data = {status: 'Suspended'};
                break;
            case ServerStatus.Unknown:
                data = {status: 'Unknown'};
                break;
            case ServerStatus.Updating:
                data = {status: 'Updating'};
                break;
            default:
                data = {status: 'Unkown'};
        }

        this.$base.attr('data-status', data.status.toLowerCase());
        this.$base.find('.status').replaceWith(statusTemplate(data));
    }

    public onButtonClick(callback: (url: string, button: JQuery) => void) {
        this.$base.find('.js-button').on('click', function (e) {
            e.preventDefault();
            let url: string = $(this).attr('href');
            callback(url, $(this));
        });
    }
}

export function createClusterNodeInstances() {
    const $base: JQuery = $(BASE_SELECTOR);
    const instances: ClusterNodeUI[] = [];

    $base.each((index, el) => {
        instances.push(new ClusterNodeUI($(el)));
    });

    return instances;
}
